import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
:root {
    --red: #e52e4d;
    --green: #65cea7;
    --border-green: #5ec39d;
    --yellow: #ffae03;
    --brown: #201d16;
    --blue: #68bde3;

    --text-tittle: #58503e;
    --text-body: #969cb3;

    --background: #fff;
    --shape: #fff;
}

* {
    margin: 0;
    padding: 0;
    font-size: 14px;
}

a { 
    color: inherit; 
    text-decoration: none;
    &:hover{
     color: inherit; 
    }
} 

header {
    color: var(--shape);
}

legend{
    color: var(--text-tittle);
}

html {
    height: 100%;
}

body {
    margin: 0;
    min-height: 100%;
    position: relative;
    padding-bottom: 9rem;
}

footer {
    color: var(--shape);
    text-align: center;
    padding: 2rem 0 1rem 0;
    position: absolute;
    bottom: 0;
}


.btn-adviceSuccess {
  color: var(--background);
  background-color: var(--green);
  border-color: var(--border-green);
  transition: filter 0.2s;
  --bs-btn-bg: var(--green);
  --bs-btn-border-color: var(--green);
  --bs-btn-hover-bg: var(--border-green);
  --bs-btn-hover-border-color: var(--border-green);
  --bs-btn-focus-shadow-rgb: 60, 153, 110;
  --bs-btn-active-bg: var(--border-green);
  --bs-btn-active-border-color: var(--border-green);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-bg: var(--green);
  --bs-btn-disabled-border-color: var(--green);
  &:hover {
    filter: brightness(0.8);
    background-color: var(--green);
    border-color: var(--border-green);
    }
}

.bg-footer {
    background-color: var(--brown);
}

.bg-header {
    background-color: var(--brown);
}

.bg-table {
    background-color: var(--blue);
}

.centralizar {
    margin-left: auto;
    margin-right: auto;
    justify-content: center;
}

.centralize {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

// font-size: 16px (Desktop)


@media (max-width: 1200px) {
        font-size: 87.5%; //14px

        img {
            display: none;
        }

        header{
                ul {
                    list-style-type: none;
                    display: flex;
                    justify-content: center;
                    margin: 0;
                }
            }
}

@media (max-width: 1000rem) {
        font-size: 93.75%; //15px 
        
        header{
            ul {
                list-style-type: none;
                display: flex;
                justify-content: center;
                margin: 0;
            }
        }  
        
        li {display: flex;}
    }

@media (max-width: 550px) {
        * {
            font-size: 11px;
        }
        img {
            display: none;
        }
        header
         {
            ul {
                list-style-type: none;
                display: block;
                justify-content: center;
                margin: 0;
            }
            svg.svg3 {
                display: none;
            }
        }
}
// REM = 1rem = font (px)


body, input, textarea, button {
    font-family: 'Roboto', sans-serif;
    font-weight: 400;
}

h1, h2, h3, h4, h5, h6, strong {
    font-weight: 600;
}

[disabled] {
    opacity: 0.6;
    cursor: not-allowed;
}

.react-modal-overlay {
    background: rgba(0, 0, 0, 0.5);

    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;

    display: flex;
    align-items: center;
    justify-content: center;
}
.ract-modal-content {
    width: 100%;
    max-width: 576px;
    background: var(--background);
    padding: 3rem;
    position: relative;
    border-radius: 0.24rem;
}

.react-modal-close {
    position: absolute;
    right: 1.5rem;
    top: 1.5rem;
    border: 0;
    background: transparent;

    transition: filter 0.2s;

    &:hover {
        filter: brightness(0.8);
    }
}
`